import { useEffect, useState } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { _FormTypeDinamic } from '../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../theme/Component/Modal';
import { FormTypeDinamic } from './FormTypeDinamic';

interface Props {
    label?: string;
    idSelector?: number;
    onChange: (value: any) => void;
    disabled?: boolean;
    filtro?: string;
}

export const EditorFormTypeDinamic = ({ idSelector, label, onChange, disabled, filtro }: Props) => {
    const { instance } = useDataBean(_FormTypeDinamic);

    const modal = useModal("Catalogo de Formularios Dinamicos", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    const getProperties = (item: any) => {
        return item?.DataBeanProperties ?? item ?? {};
    };

    const getDisplayValue = (item: any) => {
        const data = getProperties(item);

        if (!data?.CodeForm && !data?.Name) {
            return '';
        }

        return `${data.CodeForm ?? ''} - ${data.Name ?? ''}`;
    };

    useEffect(() => {
        if (idSelector) {
            getFormType();
        } else {
            setValor('');
            setObj({});
        }
    }, [idSelector]);

    const setSelected = (item: any) => {
        const data = getProperties(item);
        setObj(data);
        setValor(getDisplayValue(data));
        onChange(data);
    };

    const getFormTypeFromCatalog = () => {
        return instance.getFormTypeCatalogPorPropiedadesLike({ IDFormType: idSelector }, 1)
            .then((resp: any) => {
                const item = Array.isArray(resp) ? resp[0] : resp;
                const data = getProperties(item);

                if (!data?.IDFormType) {
                    throw new Error("Formulario dinamico no encontrado");
                }

                setSelected(item);
            });
    };

    const getFormType = () => {
        instance.getFormType(idSelector)
            .then((resp: any) => {
                setSelected(resp);
            })
            .catch(() => {
                getFormTypeFromCatalog()
                    .catch(() => {
                        toast.error("Formulario dinamico no encontrado");
                        setValor('');
                        setObj({});
                    });
            });
    };

    const returnValue = () => {
        const data = getProperties(obj);

        if (data?.IDFormType) {
            setValor(getDisplayValue(obj));
            modal.close();
            onChange(obj);
        } else {
            toast.error("Formulario dinamico no valido");
        }
    };

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione un Formulario Dinamico"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <FormTypeDinamic
                    isModal
                    filtro={filtro}
                    _onChange={(e: any) => {
                        setObj(e);
                    }}
                />
            </Modal>
        </>
    );
};
